import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import './ManageMembership.scss';

import commonConstant from '../../common/_commonConstant';
import { trimSpace, randomNumber, getCookieToken } from '../../common/_commonFunction';
import { Loading, MemberDetail } from '../../components';
import {
  fetchGetMembershipReport,
  fetchGetProfile,
  fetchGetMembershipPackage,
  fetchGetMembershipDetail,
  fetchSearchVehiclePlateInBuilding,
  fetchSearchCompanyNameInBuilding,
  fetchSearchMemberNameInBuilding,
} from '../../actions';
import {
  Badges,
  validateVehiclePlate,
  Modal,
  Checkbox,
  IconVehicle,
  validateToShowDash,
  Table,
  isAdmin,
  totalCar,
  totalMotorcycle,
  history,
  totalTenantMembers,
  totalVehicles,
  totalRecords,
  dateYYYYMMDD,
  labelVehicleType,
  validateTenantName,
  Toast,
  vehicleProvince,
  InputWithIcon,
  validateMemberName,
} from '../../helpers';

const columnHeader = [
  { 'label': 'ลำดับที่', 'className': 'number', 'sort': false, 'key': '' },
  { 'label': 'Tenant ref. no.', 'className': 'tenant-ref-no', 'sort': false, 'key': '' },
  { 'label': 'ชื่อบริษัท', 'className': 'company-name', 'sort': true, 'key': 'tenant-name' },
  { 'label': 'Member ref. no.', 'className': 'tenant-member-ref-no', 'sort': true, 'key': 'tenant-member-ref-no' },
  { 'label': 'ชื่อ', 'className': 'first-name-and-last-name', 'sort': false, 'key': '' },
  { 'label': 'นามสกุล', 'className': 'first-name-and-last-name', 'sort': false, 'key': '' },
  { 'label': 'สถานะสมาชิก', 'className': 'status', 'sort': false, 'key': '' },
  { 'label': 'Active date', 'className': 'active-date', 'sort': true, 'key': 'membership-active-date' },
  { 'label': 'Expire date', 'className': 'expire-date', 'sort': true, 'key': 'membership-expire-date' },
  { 'label': 'Member Note.', 'className': 'package', 'sort': false, 'key': '' },
  { 'label': 'เลขทะเบียน', 'className': 'vehicle-plate', 'sort': false, 'key': '' },
  { 'label': 'จังหวัด', 'className': 'vehicle-province', 'sort': false, 'key': '' },
  { 'label': 'ประเภทยานพาหนะ', 'className': 'vehicle-type', 'sort': false, 'key': '' },
  { 'label': 'สถานะรถ', 'className': 'status', 'sort': false, 'key': '' },
  { 'label': '', 'className': 'view-detail', 'sort': false, 'key': '', 'keyFuncName': 'viewDetail' },
];

class ManageMembership extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'loading': false,
      'radioButton': 'vehicle',
      'modal': null,
      'inputFilter': '',
      'filter': [],
      'filterInput': [],
      'filterCheckbox': { // for dummy select filter
        ...JSON.parse(commonConstant.defaultFilterMemberStatus),
      },
      'selectFilterCheckbox': { // for apply filter
        ...JSON.parse(commonConstant.defaultFilterMemberStatus),
      },
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortManageMembership,
      'dataAutoFill': null,
      'showAutoFill': false,
      'activeTab': 'allMember',
      'toast': null,
      'inputFilterVehicle': '',
      'inputFilterCompanyName': '',
      'inputFilterMemberName': '',
      'showAutoFillVehicle': false,
      'showAutoFillCompanyName': false,
      'showAutoFillMemberName': false,
      'dataAutoFillVehicle': null,
      'dataAutoFillCompanyName': null,
      'dataAutoFillMemberName': null,
    };

    this.modal = createRef();
    this.toast = createRef();
    this.passFuncBody = [
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && ((pageSize * (pageNumber - 1)) + (index + 1)),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && validateToShowDash(data.tenantRefNo),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && validateToShowDash(data.tenantName),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && validateToShowDash(data.tenantMemberRefNo),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && validateToShowDash(data.customerFirstName),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && validateToShowDash(data.customerLastName),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => (
        !condition && data.tenantMemberMembershipStatus ?
          <span>
            <span className={data.tenantMemberMembershipStatus === commonConstant.memberStatusActive ? 'dot-green' : 'dot-gray'} />
            <span>{data.tenantMemberMembershipStatus}</span>
          </span>
          : !condition && '-'
      ),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && validateToShowDash(dateYYYYMMDD(data.tenantMemberStartedAt)),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && validateToShowDash(dateYYYYMMDD(data.tenantMemberExpiredAt)),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && validateToShowDash(data.tenantMemberRemark),
      data => validateToShowDash(data.vehicleLicensePlate),
      data => validateToShowDash(vehicleProvince(data)),
      data => validateToShowDash(labelVehicleType(data)),
      data => (
        <span className={data.tenantMemberVehicleStatus === commonConstant.vehicleStatusActive ? 'tag-green' : ''}>
          {validateToShowDash(data.tenantMemberVehicleStatus)}
        </span>
      ),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && <span key={randomNumber()}>view details</span>,
    ];

    props.dispatch(fetchGetMembershipPackage(props.match.params.buildingID));
  }

  UNSAFE_componentWillMount() {
    if (!getCookieToken()) {
      return history.push(commonConstant.pathLogout);
    } else if (this.props.getProfile.data && isAdmin(this.props.getProfile.data)) {
      this.handleClearState();
    } else if (!this.props.getProfile.data) {
      this.props.dispatch(fetchGetProfile());
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getProfile, getMembershipReport, getMembershipDetail ,searchVehiclePlate ,searchCompanyName,searchMemberName } = this.props;

    if (nextProps.getProfile && nextProps.getProfile !== getProfile) {
      return this.handleClearState();
    } else if (nextProps.getMembershipReport && nextProps.getMembershipReport !== getMembershipReport) {
      return this.setState({ 'loading': false });
    } else if (nextProps.getMembershipDetail && nextProps.getMembershipDetail !== getMembershipDetail) {
      if (nextProps.getMembershipDetail.status === 200) {
        return this.setState({ 'modal': 'view-detail', 'loading': false });
      }
      return this.setState({ 'loading': false });
    } 
    else if (nextProps.searchCompanyName && nextProps.searchCompanyName !== searchCompanyName) {
      return this.handleItemsAutoFillCompanyName(nextProps.searchCompanyName);
    }
    else if (nextProps.searchVehiclePlate && nextProps.searchVehiclePlate !== searchVehiclePlate) {
      return this.handleItemsAutoFillVehicle(nextProps.searchVehiclePlate);
    }
    else if (nextProps.searchMemberName && nextProps.searchMemberName !== searchMemberName) {
      return this.handleItemsAutoFillMemberName(nextProps.searchMemberName);
    }
  }

  handleMemberDetail = data => {
    this.setState({ 'loading': true });
    return this.props.dispatch(fetchGetMembershipDetail(data.tenantMemberID));
  }

  handleClearState = () => {
    const { match } = this.props;

    this.setState({
      'loading': false,
      'radioButton': 'vehicle',
      'modal': null,
      'inputFilter': '',
      'filter': [],
      'filterInput': [],
      'filterCheckbox': { // for dummy select filter
        ...JSON.parse(commonConstant.defaultFilterMemberStatus),
      },
      'selectFilterCheckbox': { // for apply filter
        ...JSON.parse(commonConstant.defaultFilterMemberStatus),
      },
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortManageMembership,
      'dataAutoFill': null,
      'showAutoFill': false,
      'activeTab': 'allMember',
      'inputFilterVehicle': '',
      'inputFilterCompanyName': '',
      'inputFilterMemberName': '',
      'showAutoFillVehicle': false,
      'showAutoFillCompanyName': false,
      'showAutoFillMemberName': false,
      'dataAutoFillVehicle': null,
      'dataAutoFillCompanyName': null,
      'dataAutoFillMemberName': null,
    });

    return this.props.dispatch(fetchGetMembershipReport(
      match.params.buildingID,
      null,
      null,
      null,
      null,
      commonConstant.defaultPageSize.value,
      0,
      commonConstant.defaultSortManageMembership.key,
      commonConstant.defaultSortManageMembership.sort ? 'descending' : 'ascending',
      null,
    ));
  }

  handleValueTab = newValue => {
    const value = newValue ? newValue : this.state.activeTab;
    switch (value) {
      case 'allMember':
        return null;
      case 'car':
        return commonConstant.vehicleTypeCar;
      case 'motorcycle':
        return commonConstant.vehicleTypeMotorcycle;
      default:
        return null;
    }
  }


  handleItemsAutoFillVehicle = data => {
    try {
      const { searchVehiclePlate } = this.props;
      const items = data ? data : searchVehiclePlate;

      if (!items || items.data.length === 0) {
        return this.setState({ 'dataAutoFillVehicle': null, 'showAutoFillVehicle': false });
      }

      const dataAutoFillVehicle = items.data.map((ele, index) => (
        <div className="item" key={randomNumber()} onClick={() => this.handleFilterInputVehicle(ele)}>
          <span className="text" id={`vehicle-auto-fill-${index}`}>
            {ele}
          </span>
        </div>
      ));

      return this.setState({ dataAutoFillVehicle, 'showAutoFillVehicle': true });
    } catch (error) {
      return null;
    }
  }

  handleItemsAutoFillCompanyName = data => {
    try {
      const { searchCompanyName } = this.props;
      const items = data ? data : searchCompanyName;

      if (!items || items.data.length === 0) {
        return this.setState({ 'dataAutoFillCompanyName': null, 'showAutoFillCompanyName': false });
      }

      const dataAutoFillCompanyName = items.data.map((ele, index) => (
        <div className="item" key={randomNumber()} onClick={() => this.handleFilterInputCompanyName(ele)}>
          <span id={`company-auto-fill-${index}`}>
            {ele}
          </span>
        </div>
      ));

      return this.setState({ dataAutoFillCompanyName, 'showAutoFillCompanyName': true });
    } catch (error) {
      return null;
    }
  }

  handleItemsAutoFillMemberName = data => {
    try {
      const { searchMemberName } = this.props;
      const items = data ? data : searchMemberName;

      const uniqueMemberNameObject = new Set(items.data);
      const uniqueMemberNameList = Array.from(uniqueMemberNameObject);

      if (!uniqueMemberNameList || uniqueMemberNameList.length === 0) {
        return this.setState({ 'dataAutoFillMemberName': null, 'showAutoFillMemberName': false });
      }

      const dataAutoFillMemberName = uniqueMemberNameList.map((ele, index) => (
        <div className="item" key={randomNumber()} onClick={() => this.handleFilterInputMemberName(ele)}>
          <span className="text" id={`member-name-auto-fill-${index}`}>
            {ele}
          </span>
        </div>
      ));

      return this.setState({ dataAutoFillMemberName, 'showAutoFillMemberName': true });
    } catch (error) {
      return null;
    }
  }

  handleSumFilter = () => {
    const { selectFilterCheckbox } = this.state;
    let sum = 0;

    Object.keys(selectFilterCheckbox).forEach(ele => selectFilterCheckbox[ele].select ? sum += 1 : null);

    return (
      <span className="box-sum">
        <span>Filter</span>
        {sum ? <span className="sum" id="filter-summary">{sum}</span> : null}
      </span>
    );
  }

  handleShowModal = (value) => this.setState({
    'modal': this.state.modal ? null : value,
    'selectFilterCheckbox': { ...this.state.filterCheckbox }, // clear filter on modal
  });

  handleHeaderModal = () => {
    try {
      const { modal } = this.state;

      switch (modal) {
        case 'filter':
          return this.handleSumFilter();
        case 'view-detail':
          return null;
        case 'create-member':
          return null;
        default:
          return null;
      }
    } catch (error) {
      return null;
    }
  }

  handleBodyModal = () => {
    try {
      const { modal, selectFilterCheckbox } = this.state;

      switch (modal) {
        case 'filter':
          return (
            <div className="body-modal-filter-manage-membership">
              <div className="box">
                <div className="box-filter">
                  <div className="label">สถานะลูกค้า</div>
                  <Checkbox
                    className="filter"
                    id="filter-active"
                    label={selectFilterCheckbox.active.label}
                    checked={selectFilterCheckbox.active.select}
                    handleSelect={() => this.handleFilterModal('active')}
                  />
                  <Checkbox
                    id="filter-inactive"
                    label={selectFilterCheckbox.inactive.label}
                    checked={selectFilterCheckbox.inactive.select}
                    handleSelect={() => this.handleFilterModal('inactive')}
                  />
                  <Checkbox
                    id="filter-expired"
                    label={selectFilterCheckbox.expired.label}
                    checked={selectFilterCheckbox.expired.select}
                    handleSelect={() => this.handleFilterModal('expired')}
                  />
                </div>
                <Button className="btn-apply-filter btn-primary" onClick={this.handleApplyFilter}>Apply</Button>
              </div>
            </div>
          );
        case 'view-detail':
          return null;
        case 'create-member':
          return null;
        default:
          return null;
      }
    } catch (error) {
      return null;
    }
  }

  handleFilterModal = key => { // handle filter modal (checkbox)
    try {
      return this.setState({
        'selectFilterCheckbox': {
          ...this.state.selectFilterCheckbox,
          [key]: { ...this.state.selectFilterCheckbox[key], 'select': !this.state.selectFilterCheckbox[key].select },
        },
      });
    } catch (error) {
      return null;
    }
  }

  handleApplyFilter = () => { // handle apply filter modal (checkbox)
    try {
      const { selectFilterCheckbox } = this.state;
      const { match } = this.props;
      const arr = this.handleBadgesItems();

      this.setState({
        'modal': null,
        'filterCheckbox': { ...selectFilterCheckbox },
        'filter': arr,
        'loading': true,
        'pageSize': commonConstant.defaultPageSize,
        'pageNumber': 1,
      });

      return this.props.dispatch(fetchGetMembershipReport(
        match.params.buildingID,
        this.handleFilterByType('member-status', arr),
        this.handleValueTab(),
        this.handleFilterByType('input-vehicle', arr),
        this.handleFilterByType('input-company', arr),
        commonConstant.defaultPageSize.value,
        0,
        commonConstant.defaultSortManageMembership.key,
        commonConstant.defaultSortManageMembership.sort ? 'descending' : 'ascending',
        this.handleFilterByType('input-member-name', arr),
      ));
    } catch (error) {
      return null;
    }
  }

  handleResetFilter = () => { // handle reset filter from modal (checkbox)
    const { filterInput } = this.state;
    const { match } = this.props;

    this.setState({
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortManageMembership,
      'filter': [...filterInput],
      'filterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterMemberStatus),
      },
      'selectFilterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterMemberStatus),
      },
    });

    return this.props.dispatch(fetchGetMembershipReport(
      match.params.buildingID,
      null,
      this.handleValueTab(),
      this.handleFilterByType('input-vehicle'),
      this.handleFilterByType('input-company'),
      commonConstant.defaultPageSize.value,
      0,
      commonConstant.defaultSortManageMembership.key,
      commonConstant.defaultSortManageMembership.sort ? 'descending' : 'ascending',
      this.handleFilterByType('input-member-name'),
    ));
  }

  handleFilterByType = (type, filter) => {
    const newFilter = filter ? filter : this.state.filter;
    const arr = [];

    newFilter.forEach(ele => ele.type === type ? type === 'input-vehicle' ? arr.push(trimSpace(ele.value)) : arr.push(ele.value) : null);

    if (type === 'member-status' && arr.length === 3) { // check filter member-status is check all return null to query param
      return null;
    }

    return arr.join(',');
  }

  handleBadgesItems = newFilterInput => { // handle filter for badges
    try {
      const { selectFilterCheckbox, filterInput } = this.state;
      const input = newFilterInput ? newFilterInput : filterInput;
      const arr = input ? [...input] : [];

      Object.keys(selectFilterCheckbox).forEach(key => {
        if (selectFilterCheckbox[key].select) {
          arr.push({
            'label': selectFilterCheckbox[key].label,
            'value': selectFilterCheckbox[key].value,
            'key': 'filterCheckbox',
            'keyName': selectFilterCheckbox[key].keyName,
            'type': selectFilterCheckbox[key].type,
          });
        }
      });

      return arr;
    } catch (error) {
      return null;
    }
  }

  handleRemoveFilter = index => { // remove filter from badges
    const { filter, filterInput, filterCheckbox } = this.state;
    const { match } = this.props;
    let newFilterInput = null;

    if (filter[index].key === 'filterInput') {
      newFilterInput = filterInput.filter(element => element.label !== filter[index].label);
    } else if (filter[index].key === 'filterCheckbox') {
      filterCheckbox[filter[index].keyName].select = false;
    }
    const arr = this.handleBadgesItems(newFilterInput ? newFilterInput : null);

    this.setState({
      'filter': arr,
      filterCheckbox,
      'filterInput': newFilterInput ? newFilterInput : filterInput,
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
    });

    return this.props.dispatch(fetchGetMembershipReport(
      match.params.buildingID,
      this.handleFilterByType('member-status', arr),
      this.handleValueTab(),
      this.handleFilterByType('input-vehicle', arr),
      this.handleFilterByType('input-company', arr),
      commonConstant.defaultPageSize.value,
      0,
      commonConstant.defaultSortManageMembership.key,
      commonConstant.defaultSortManageMembership.sort ? 'descending' : 'ascending',
      this.handleFilterByType('input-member-name', arr),
    ));
  }

  handleActiveTab = activeTab => {
    const { match } = this.props;

    this.setState({ // handle change tab
      activeTab,
      'dataAutoFill': null,
      'showAutoFill': false,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortManageMembership,
      'radioButton': 'vehicle',
      'modal': null,
      'inputFilter': '',
      'loading': true,
      'showAutoFillVehicle': false,
      'showAutoFillCompanyName': false,
      'showAutoFillMemberName': false,
      'dataAutoFillVehicle': null,
      'dataAutoFillCompanyName': null,
      'dataAutoFillMemberName': null,
      'inputFilterVehicle': '',
      'inputFilterCompanyName': '',
      'inputFilterMemberName': '',
    });

    return this.props.dispatch(fetchGetMembershipReport(
      match.params.buildingID,
      this.handleFilterByType('member-status'),
      this.handleValueTab(activeTab),
      this.handleFilterByType('input-vehicle'),
      this.handleFilterByType('input-company'),
      commonConstant.defaultPageSize.value,
      0,
      commonConstant.defaultSortManageMembership.key,
      commonConstant.defaultSortManageMembership.sort ? 'descending' : 'ascending',
      this.handleFilterByType('input-member-name'),

    ));
  }

  handlePageChange = pageNumber => {
    const { pageSize, sort } = this.state;
    const { match } = this.props;

    this.setState({ pageNumber, 'loading': true });

    return this.props.dispatch(fetchGetMembershipReport(
      match.params.buildingID,
      this.handleFilterByType('member-status'),
      this.handleValueTab(),
      this.handleFilterByType('input-vehicle'),
      this.handleFilterByType('input-company'),
      pageSize.value,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('input-member-name'),
    ));
  }

  handlePageSize = pageSize => {
    const { sort } = this.state;
    const { match } = this.props;

    this.setState({ pageSize, 'pageNumber': 1, 'loading': true });

    return this.props.dispatch(fetchGetMembershipReport(
      match.params.buildingID,
      this.handleFilterByType('member-status'),
      this.handleValueTab(),
      this.handleFilterByType('input-vehicle'),
      this.handleFilterByType('input-company'),
      pageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('input-member-name'),
    ));
  }

  handleSort = sort => {
    const { pageSize, pageNumber } = this.state;
    const { match } = this.props;

    this.setState({ sort, 'loading': true });

    return this.props.dispatch(fetchGetMembershipReport(
      match.params.buildingID,
      this.handleFilterByType('member-status'),
      this.handleValueTab(),
      this.handleFilterByType('input-vehicle'),
      this.handleFilterByType('input-company'),
      pageSize.value,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('input-member-name'),
    ));
  }

  handleToast = () => {
    const { toast } = this.state;

    switch (toast) {
      case 'create-member':
        return (
          <span className="text" id="toast-create-member">
            <span className="icon icon-check" />
            เพิ่ม Member สำเร็จ
          </span>
        );
      case 'update-member':
        return (
          <span className="text" id="toast-update-member">
            <span className="icon icon-check" />
            บันทึกสำเร็จ
          </span>
        );
      default:
        return;
    }
  }

  handleSetToast = (value) => {
    this.setState({ 'toast': value ? value : null });

    if (value) {
      this.toast.current.handleShowToast();
    }
    return null;
  }


  handleKeyPressVehicle = event => {
    if (event.key === 'Enter') {
      return this.handleFilterInputVehicle();
    }
  }

  handleFilterInputVehicle = async newInputFilterVehicle => { // add filter from input
    try {
      const { inputFilterVehicle, filterInput } = this.state;
      const { match } = this.props;
      const input = newInputFilterVehicle ? newInputFilterVehicle : inputFilterVehicle;
      const check = await filterInput.find(element => element.value === input) ? true : false;

      if (check || !input) {
        return null;
      }

      const newFilterInput = [...filterInput, {
        'label': input,
        'value': input,
        'key': 'filterInput',
        'keyName': 'vehicle',
        'type': 'input-vehicle',
      }];
      const arr = this.handleBadgesItems(newFilterInput);

      this.setState({
        'filterInput': newFilterInput,
        'filter': arr,
        'loading': true,
        'pageSize': commonConstant.defaultPageSize,
        'pageNumber': 1,
        'dataAutoFill': null,
        'showAutoFillVehicle': false,
        'showAutoFillCompanyName': false,
        'showAutoFillMemberName': false,
        'dataAutoFillVehicle': null,
        'dataAutoFillCompanyName': null,
        'dataAutoFillMemberName': null,
        'inputFilterVehicle': '',
        'inputFilterCompanyName': '',
        'inputFilterMemberName': '',
      });

      return this.props.dispatch(fetchGetMembershipReport(
        match.params.buildingID,
        this.handleFilterByType('member-status', arr),
        this.handleValueTab(),
        this.handleFilterByType('input-vehicle', arr),
        this.handleFilterByType('input-company', arr),
        commonConstant.defaultPageSize.value,
        0,
        commonConstant.defaultSortManageMembership.key,
        commonConstant.defaultSortManageMembership.sort ? 'descending' : 'ascending',
        this.handleFilterByType('input-member-name', arr),
      ));
    } catch (error) {
      return null;
    }
  }

  handleChangeVehicle = event => {
    const { match } = this.props;

    if (validateVehiclePlate(event.target.value)) {
      if (trimSpace(event.target.value).length >= 3) { // handle auto fill
        this.setState({ 'inputFilterVehicle': event.target.value });
        return this.props.dispatch(fetchSearchVehiclePlateInBuilding(
          match.params.buildingID,
          event.target.value,
        ));
      }
      return this.setState({ 'inputFilterVehicle': event.target.value });
    }
    return null;
  }


  handleKeyPressCompanyName = event => {
    if (event.key === 'Enter') {
      return this.handleFilterInputCompanyName();
    }
  }

  handleFilterInputCompanyName = async newInputFilterCompanyName => { // add filter from input
    try {
      const { inputFilterCompanyName, filterInput } = this.state;
      const { match } = this.props;
      const input = newInputFilterCompanyName ? newInputFilterCompanyName : inputFilterCompanyName;
      const check = await filterInput.find(element => element.value === input) ? true : false;

      if (check || !input) {
        return null;
      }

      const newFilterInput = [...filterInput, {
        'label': input,
        'value': input,
        'key': 'filterInput',
        'keyName': 'company',
        'type': 'input-company',
      }];
      const arr = this.handleBadgesItems(newFilterInput);

      this.setState({
        'filterInput': newFilterInput,
        'filter': arr,
        'loading': true,
        'pageSize': commonConstant.defaultPageSize,
        'pageNumber': 1,
        'dataAutoFill': null,
        'showAutoFill': false,
        'showAutoFillVehicle': false,
        'showAutoFillCompanyName': false,
        'showAutoFillMemberName': false,
        'dataAutoFillVehicle': null,
        'dataAutoFillCompanyName': null,
        'dataAutoFillMemberName': null,
        'inputFilterVehicle': '',
        'inputFilterCompanyName': '',
        'inputFilterMemberName': '',
      });

      return this.props.dispatch(fetchGetMembershipReport(
        match.params.buildingID,
        this.handleFilterByType('member-status', arr),
        this.handleValueTab(),
        this.handleFilterByType('input-vehicle', arr),
        this.handleFilterByType('input-company', arr),
        commonConstant.defaultPageSize.value,
        0,
        commonConstant.defaultSortManageMembership.key,
        commonConstant.defaultSortManageMembership.sort ? 'descending' : 'ascending',
        this.handleFilterByType('input-member-name', arr),
      ));
    } catch (error) {
      return null;
    }
  }  

  handleChangeCompanyName = event => {
    const { match } = this.props;

    if (validateTenantName(event.target.value)) {
      if (trimSpace(event.target.value).length > 0) { // handle auto fill
        this.setState({ 'inputFilterCompanyName': event.target.value });
        return this.props.dispatch(fetchSearchCompanyNameInBuilding(
          match.params.buildingID,
          event.target.value,
        ));
      }
      return this.setState({ 'inputFilterCompanyName': event.target.value });
    }
    return null;
  }

  handleKeyPressMemberName = event => {
    if (event.key === 'Enter') {
      return this.handleFilterInputMemberName();
    }
  }

  handleFilterInputMemberName = async newInputFilterMemberName => { // add filter from input
    try {
      const { inputFilterMemberName, filterInput } = this.state;
      const { match } = this.props;
      const input = newInputFilterMemberName ? newInputFilterMemberName : inputFilterMemberName;
      const check = await filterInput.find(element => element.value === input) ? true : false;

      if (check || !input) {
        return null;
      }

      const newFilterInput = [...filterInput, {
        'label': input,
        'value': input,
        'key': 'filterInput',
        'keyName': 'member-name',
        'type': 'input-member-name',
      }];
      const arr = this.handleBadgesItems(newFilterInput);

      this.setState({
        'filterInput': newFilterInput,
        'filter': arr,
        'loading': true,
        'pageSize': commonConstant.defaultPageSize,
        'pageNumber': 1,
        'dataAutoFill': null,
        'showAutoFill': false,
        'showAutoFillVehicle': false,
        'showAutoFillCompanyName': false,
        'showAutoFillMemberName': false,
        'dataAutoFillVehicle': null,
        'dataAutoFillCompanyName': null,
        'dataAutoFillMemberName': null,
        'inputFilterVehicle': '',
        'inputFilterCompanyName': '',
        'inputFilterMemberName': '',
      });

      return this.props.dispatch(fetchGetMembershipReport(
        match.params.buildingID,
        this.handleFilterByType('member-status', arr),
        this.handleValueTab(),
        this.handleFilterByType('input-vehicle', arr),
        this.handleFilterByType('input-company', arr),
        commonConstant.defaultPageSize.value,
        0,
        commonConstant.defaultSortManageMembership.key,
        commonConstant.defaultSortManageMembership.sort ? 'descending' : 'ascending',
        this.handleFilterByType('input-member-name', arr),
      ));
    } catch (error) {
      return null;
    }
  }  

  handleChangeMemberName = event => {
    const { match } = this.props;

    if (validateMemberName(event.target.value)) {
      if (trimSpace(event.target.value).length > 0) { // handle auto fill
        this.setState({ 'inputFilterMemberName': event.target.value });
        return this.props.dispatch(fetchSearchMemberNameInBuilding(
          match.params.buildingID,
          event.target.value,
        ));
      }
      return this.setState({ 'inputFilterMemberName': event.target.value });
    }
    return null;
  }

  render() {
    const {
      loading,
      modal,
      filter,
      activeTab,
      pageSize,
      pageNumber,
      sort,
      toast,
      inputFilterVehicle,
      inputFilterCompanyName,
      inputFilterMemberName,
      showAutoFillVehicle,
      showAutoFillCompanyName,
      showAutoFillMemberName,
      dataAutoFillVehicle,
      dataAutoFillCompanyName,
      dataAutoFillMemberName,
    } = this.state;
    const { getMembershipReport } = this.props;

    if (!getMembershipReport.data) {
      return <Loading />;
    }

    return (
      <div className="ManageMembership layout-box-page">
        {loading ? <Loading /> : null}
        <Toast
          text={toast && this.handleToast()}
          id="toast"
          handleClearState={this.handleSetToast}
          ref={this.toast}
        />
        <div className="tool-bar">
          <div className="box-filter">
            <div className="box">
              <div className="box-input">
                <InputWithIcon
                  id="search-vehicle"
                  template="b"
                  icon="fas fa-search"
                  value={inputFilterVehicle}
                  placeholder="เลขทะเบียนรถ"
                  onKeyPress={this.handleKeyPressVehicle}
                  onChange={this.handleChangeVehicle}
                  showAutoFill={showAutoFillVehicle}
                  dataAutoFill={dataAutoFillVehicle}
                  maxLength = {'9'}
                />
              </div>
              <div className="box-input">
                <InputWithIcon
                  id="search-company-name"
                  template="b"
                  icon="fas fa-search"
                  value={inputFilterCompanyName}
                  placeholder="ชื่อบริษัท"
                  onKeyPress={this.handleKeyPressCompanyName}
                  onChange={this.handleChangeCompanyName}
                  showAutoFill={showAutoFillCompanyName}
                  dataAutoFill={dataAutoFillCompanyName}
                />
              </div>
              <div className="box-input">
                <InputWithIcon
                  id="search-member-name"
                  template="b"
                  icon="fas fa-search"
                  value={inputFilterMemberName}
                  placeholder="ชื่อจริง หรือ นามสกุล"
                  onKeyPress={this.handleKeyPressMemberName}
                  onChange={this.handleChangeMemberName}
                  showAutoFill={showAutoFillMemberName}
                  dataAutoFill={dataAutoFillMemberName}
                />
              </div>
            </div>
          </div>
          <div className="btn-search-filter">
            <Button className="btn-secondary btn-filter" id="btn-filter" onClick={() => this.handleShowModal('filter')}>
              Filter
              <span className="icon fas fa-filter" />
            </Button>
          </div>
        </div>
        <Badges items={filter} handleRemove={this.handleRemoveFilter} hr />
        <div className="box-tabs">
          <span className={`tab${activeTab === 'allMember' ? ' active' : ''}`} onClick={() => this.handleActiveTab('allMember')} id="tab-all-member">
            Member ทั้งหมด
          </span>
          <span className={`tab${activeTab === 'car' ? ' active' : ''}`} onClick={() => this.handleActiveTab('car')} id="tab-car">
            รถยนต์
          </span>
          <span className={`tab${activeTab === 'motorcycle' ? ' active' : ''}`} onClick={() => this.handleActiveTab('motorcycle')} id="tab-motorcycle">
            รถจักรยานยนต์
          </span>     
          <div className="box-create">
            <Button
              id="btn-create-member"
              className="btn-primary btn-excel"
              onClick={() => this.handleShowModal('create-member')}
            >
              <span className="icon icon-add" />
              สร้าง Member
            </Button>          
          </div>  
        </div>
        <div className={`section-table${filter.length > 0 ? ' mr' : ''}`}>
          <div className="box-detail">
            <span>
              จำนวน Member ทั้งหมด
              <span className="green" id="total-member">{validateToShowDash(totalTenantMembers(getMembershipReport))}</span>
              คน
            </span>
            <span>
              จำนวนรถทั้งหมด
              <span className="green" id="total-vehicle">{validateToShowDash(totalVehicles(getMembershipReport))}</span>
              คัน
            </span>
            <span>
              <IconVehicle className="icon" name="icon_car" />
              <span className="green" id="total-car">{validateToShowDash(totalCar(getMembershipReport))}</span>
              คัน
            </span>
            <span>
              <IconVehicle className="icon" name="icon_motorcycle" />
              <span className="green" id="total-motorcycle">{validateToShowDash(totalMotorcycle(getMembershipReport))}</span>
              คัน
            </span>
          </div>
          <Table
            id="table-manage-member"
            columnHeader={columnHeader}
            data={getMembershipReport.data}
            passFuncBody={this.passFuncBody}
            maxData={validateToShowDash(totalRecords(getMembershipReport))}
            pageSize={pageSize}
            pageNumber={pageNumber}
            handlePageChange={this.handlePageChange}
            sort={sort}
            isSort
            handleSort={this.handleSort}
            handlePageSize={this.handlePageSize}
            filter={filter}
            passFuncClick={{
              'viewDetail': item => this.handleMemberDetail(item),
            }}
            groupItemsCondition={(data, prevData) => data?.tenantMemberID === prevData?.tenantMemberID}
          />
        </div>
        {
          modal && modal !== 'filter' ?
            <MemberDetail
              type={modal}
              handleClearState={() => {
                this.handleShowModal();
                this.handleClearState();
              }}
              handleCloseDetail={() => this.setState({ 'modal': null })}
              handleSetToast={this.handleSetToast}
            />
            : null
        }
        <Modal
          show={modal === 'filter' ? true : false}
          header={this.handleHeaderModal()}
          headerTemplate="a"
          handleToggle={this.handleShowModal}
          iconOther={
            modal === 'filter' ?
              <span className="reset" id="modal-reset-filter" onClick={this.handleResetFilter}>
                <span className="icon fas fa-redo-alt" />
                <span className="text">Reset</span>
              </span>
              : null
          }
          ref={this.modal}
        >
          {this.handleBodyModal()}
        </Modal>
      </div>
    );
  }
}

ManageMembership.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'params': PropTypes.shape({
      'buildingID': PropTypes.string,
    }).isRequired,
  }).isRequired,
  'getProfile': PropTypes.shape({
    'data': PropTypes.shape({}),
  }),
  'getMembershipReport': PropTypes.shape({
    'data': PropTypes.array,
  }),
  'getMembershipDetail': PropTypes.shape({
    'status': PropTypes.any,
  }),
  'searchVehiclePlate': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.array,
  }),
  'searchCompanyName': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.array,
  }),
  'searchMemberName': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.array,
  }),
};

const mapStateToProps = ({
  getProfile,
  getMembershipReport,
  getMembershipDetail,
  searchVehiclePlate,
  searchCompanyName,
  searchMemberName,
}) => ({
  getProfile,
  getMembershipReport,
  getMembershipDetail,
  searchVehiclePlate,
  searchCompanyName,
  searchMemberName,
});

export default connect(mapStateToProps)(ManageMembership);
